import React, { useState } from 'react';
import "./InstructionsBox.css";
import { FaClipboard, FaCheckCircle } from 'react-icons/fa'; // Import FaCheckCircle for success state
import { Alert, Snackbar } from '@mui/material';

const InstructionsBox = () => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [copySuccessIndex, setCopySuccessIndex] = useState(null); // State to track success icon

    const instructions = [
        { key: "$requesterName$", value: "შემსრულებლის სახელი" },
        { key: "$receiverName$", value: "ადრესატის სახელი" },
        { key: "$caseNumber$", value: "განაცხადის ნომერი" },
        { key: "$caseDate$", value: "განაცხადის შექმნის თარიღი" },
        { key: "$address$", value: "სრული მისამართი" },
        { key: "$permitType$", value: "ნებართვის ტიპის სათაური" },
        { key: "$objectName$", value: "ობიექტის დასახელება და ფუნქციური დანიშნულება" },
        { key: "$objectOwnerIdentificationNumber$", value: "ობიექტის მფლობელის საიდენტიფიკაციო კოდი" },
        { key: "$exploitationIdentificationNumber$", value: "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი" },
        { key: "$signee$", value: "შიდა დოკუმენტის ხელმომწერი" }
    ];

    const copyToClipboard = async (textToCopy, index) => {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy);
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            textArea.style.position = "absolute";
            textArea.style.left = "-999999px";
            document.body.prepend(textArea);
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
        }
        setAlertOpen(true);
        setCopySuccessIndex(index);
        setTimeout(() => setCopySuccessIndex(null), 2000);
    };

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertOpen(false);
    };

    return (
        <div className="instructions-box">
            <table className="instructions-box-table">
                <thead className="instructions-box-thead">
                <tr className="instructions-box-tr">
                    <th className="instructions-box-th">ცვლადი</th>
                    <th className="instructions-box-th">მნიშვნელობა</th>
                    <th className="instructions-box-th">კოპირება</th>
                </tr>
                </thead>
                <tbody className="instructions-box-tbody">
                {instructions.map((instruction, index) => (
                    <tr key={index} className="instructions-box-tr">
                        <td className="instructions-box-td instructions-box-key">{instruction.key}</td>
                        <td className="instructions-box-td instructions-box-value">{instruction.value}</td>
                        <td className="instructions-box-td">
                            {copySuccessIndex === index ? (
                                <FaCheckCircle className="instructions-box-copy-success" />
                            ) : (
                                <FaClipboard className="instructions-box-copy-icon" onClick={() => copyToClipboard(instruction.key, index)} />
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleAlertClose} severity="success" sx={{ width: '100%' }}>
                    დაკოპირდა!
                </Alert>
            </Snackbar>
        </div>
    );
};

export default InstructionsBox;
